<script>
import moment from 'moment';
import Chart from 'chart.js';
import { Bar, mixins } from 'vue-chartjs';

Chart.defaults.global.defaultFontFamily = 'Montserrat, sans-serif';

const labelsStyle = {
  fontColor: '#a0aec0',
  fontStyle: '800',
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: false,
    labels: {
      boxWidth: 2,
      padding: 20,
      usePointStyle: true,
    },
  },
  tooltips: {
    callbacks: {
      title: (tooltipItem) => moment(+tooltipItem[0].xLabel).format('DD. MMM Y H:mm'),
    },
  },
  scales: {
    xAxes: [{
      ticks: {
        ...labelsStyle,
        padding: 6,
        autoSkipPadding: 20,
        maxRotation: 0,
      },
      gridLines: {
        display: false,
      },
    }],
    yAxes: [{
      ticks: {
        ...labelsStyle,
        beginAtZero: true,
        min: 0,
        precision: 1,
        fontSize: 12,
        padding: 10,
        autoSkipPadding: 8,
      },
      gridLines: {
        tickMarkLength: 4,
        borderDash: [2],
        zeroLineBorderDash: [0],
        zeroLineWidth: 1,
      },
    }],
  },
};

export default {
  name: 'BarChart',
  extends: Bar,

  mixins: [mixins.reactiveProp],

  data() {
    return {
      options,
    };
  },

  computed: {
    dateFormat() {
      const labels = [...this.chartData.labels];
      const first = moment(+labels.shift());
      const last = moment(+labels.pop());

      if (last.diff(first, 'days') <= 1) {
        return 'H:mm';
      }
      if (last.diff(first, 'months') > 2) {
        return 'MMM YY';
      }
      return 'D MMM';
    },
  },

  watch: {
    '$route.params.lang'() {
       this.$data._chart.update();
    },
  },

  mounted() {
    this.options.scales.xAxes[0].ticks.callback = label => moment(+label).format(this.dateFormat);
    this.renderChart(this.chartData, this.options);
  },

  methods: {
    setVisibleDataset(datasetIdx) {
      const chart = this.$data._chart;
      let datasetsCount = this.chartData.datasets.length;

      while (datasetsCount > 0) {
        const idx = datasetsCount - 1;
        const meta = chart.getDatasetMeta(idx);

        if (!!meta) {
          meta.hidden = idx !== datasetIdx;
          chart.update();
        }

        datasetsCount--;
      }
    },
  },
};
</script>
